import { PREDICTION_FEATURE_TO_PAGE } from "../../core/constants";

export function getPredictionReplayTarget(item, featureToPage = PREDICTION_FEATURE_TO_PAGE) {
  const targetPage = featureToPage[item?.feature];
  const replayable = Boolean(item?.has_replay && item?.prediction_id && targetPage);
  return { replayable, targetPage };
}

export const PREDICTION_FEATURE_META = {
  western: { icon: "☉", accent: "primary" },
  chinese: { icon: "☯", accent: "secondary" },
  tarot: { icon: "⊕", accent: "tertiary" },
  wedding: { icon: "♡", accent: "secondary" },
  couple_match: { icon: "囍", accent: "primary" },
};

export const READING_HISTORY_FEATURE_FILTERS = [
  { id: null, labelKey: "reading_history_filter_all", icon: "◎" },
  { id: "western", labelKey: "reading_history_filter_western", icon: PREDICTION_FEATURE_META.western.icon },
  { id: "chinese", labelKey: "reading_history_filter_chinese", icon: PREDICTION_FEATURE_META.chinese.icon },
  { id: "tarot", labelKey: "reading_history_filter_tarot", icon: PREDICTION_FEATURE_META.tarot.icon },
  { id: "wedding", labelKey: "reading_history_filter_wedding", icon: PREDICTION_FEATURE_META.wedding.icon },
  { id: "couple_match", labelKey: "reading_history_filter_couple_match", icon: PREDICTION_FEATURE_META.couple_match.icon },
];

function startOfDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function groupReadingsByDate(items, { locale, t, now = new Date() }) {
  if (!items?.length) return [];

  const today = startOfDay(now);
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const groups = [];
  const indexByKey = new Map();

  items.forEach((item) => {
    const created = new Date(item.created_at);
    const day = startOfDay(created);
    const dayKey = day.toISOString();

    let label;
    if (day.getTime() === today.getTime()) {
      label = t("reading_history_group_today");
    } else if (day.getTime() === yesterday.getTime()) {
      label = t("reading_history_group_yesterday");
    } else {
      label = new Intl.DateTimeFormat(locale === "vi" ? "vi-VN" : "en-US", {
        month: "short",
        day: "numeric",
        year: created.getFullYear() !== now.getFullYear() ? "numeric" : undefined,
      }).format(created);
    }

    if (!indexByKey.has(dayKey)) {
      const group = { key: dayKey, label, items: [] };
      indexByKey.set(dayKey, groups.length);
      groups.push(group);
    }
    groups[indexByKey.get(dayKey)].items.push(item);
  });

  return groups;
}
